import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicUserPasswordService {
  constructor(private http: HttpClient) {}

  getLinkData(linkId: string) {
    return this.http.post(environment.endPoints.getuserpasswordlinkdata, { link_id: linkId }).pipe(first()).toPromise();
  }

  setPassword(linkId: string, password: string) {
    return this.http.post(environment.endPoints.setuserpasswordwithlink, { link_id: linkId, password }).pipe(first()).toPromise();
  }
}
